module.exports = __webpack_public_path__ + "media/src/images/page01_zu_worksheet-423bb9e05b4821586985fe67cfaa8458.gif";